import apiClient from './config';

// ============================================
// OWNER API ENDPOINTS
// ============================================

// Base URL for owner endpoints
const OWNER_BASE = '/owner/analytics';

// ============================================
// OWNER ANALYTICS
// ============================================
export const ownerAnalyticsAPI = {
  // Get platform overview
  getOverview: (params) => apiClient.get(`${OWNER_BASE}/overview`, { params }),

  // Get revenue metrics
  getRevenue: (params) => apiClient.get(`${OWNER_BASE}/revenue`, { params }),

  // Get user analytics
  getUsers: (params) => apiClient.get(`${OWNER_BASE}/users`, { params }),

  // Get content analytics
  getContent: (params) => apiClient.get(`${OWNER_BASE}/content`, { params }),

  // Get engagement analytics
  getEngagement: (params) => apiClient.get(`${OWNER_BASE}/engagement`, { params }),

  // Get conversion funnel
  getFunnel: (params) => apiClient.get(`${OWNER_BASE}/funnel`, { params }),

  // Get owner insights
  getInsights: (params) => apiClient.get(`${OWNER_BASE}/insights`, { params }),

  // Get comprehensive analytics (all endpoints combined)
  getComprehensive: (params) => apiClient.get(`${OWNER_BASE}/comprehensive`, { params }),
};

